import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const okendoProductRatingSummary: ComponentTemplate = {
  id: "cb187da5-41b4-4b57-91fd-74a70f8ca3d0",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Okendo Product Rating",
  leftBarCategory: { main: "productIntegrations", subCategory: "okendo" },
  preview: "integrations/okendo-rating.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  tags: ["reviews", "star"],
  template: {
    id: "$uid",
    type: "okendoProductRatingSummary",
    props: {},
  },
};
